import { Box, Flex, Typography, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { jewlr_t } from "helpers/application"

import { TitleWithLine } from "../components"

import { GemLink } from "./components"
import {
  gemStones as getGemStones,
  birthStones as getBirthStones,
} from "./gems"
import GemstonesBlock from "./gemstones-block"
import TitleSection from "./titleSection"

const GenuineGemstones = ({ refs }) => {
  const gemStones = getGemStones()
  const birthStones = getBirthStones()

  return (
    <Box contain px={{ _: 1, tablet: 0 }}>
      <TitleSection
        gemRefs={(ref) => {
          refs.genuineGemtones = ref
        }}
        text={`Genuine gemstones form naturally in the earth over millions of years.
      Their variations and beauty make every ${jewlr_t("terms.jewelry")} piece
      unique.`}
        title="Genuine Birthstones"
        titleAs="h2"
      />
      <TitleWithLine as="div" mb={3}>
        <GemLink
          data-lc="genuine-gemstones"
          fontSize={16}
          to="/helpdesk/a/682/birthstones-explained"
        >
          Learn More About Genuine Birthstones
        </GemLink>
      </TitleWithLine>
      <Flex
        flexWrap="wrap"
        margin="auto"
        pb={{ _: 2, tablet: 6 }}
        pl={{ desktop: "60px" }}
        width={{ tablet: "75%" }}
      >
        {birthStones.map((bstone) => (
          <Box
            alignItems="center"
            display={{ _: "block", tablet: "flex" }}
            flex="0 0 50%"
            key={`gem-${bstone.text}`}
            mb={{ _: 3, tablet: 4 }}
            px={{ _: "4px", tablet: 2 }}
          >
            <Box flex="0 0 auto" textAlign={{ _: "center", tablet: "right" }}>
              <Image
                alt={bstone.text}
                mb={{ _: 1, tablet: 0 }}
                src={bstone.photo}
                width="65px"
              />
            </Box>

            <Box
              flex="0 0 auto"
              px={1}
              textAlign={{ _: "center", tablet: "left" }}
              width={{ tablet: "100%" }}
            >
              <Typography bold pb="4px">
                {bstone.text} – {bstone.month}
              </Typography>

              <Typography pb="4px">{bstone.dscr}</Typography>
            </Box>
          </Box>
        ))}
      </Flex>
      <TitleWithLine mb={{ _: 2, tablet: 4 }}>
        Other Genuine Gemstones
      </TitleWithLine>
      <Box ml={{ desktop: "160px", tablet: "95px" }}>
        <GemstonesBlock gemStones={gemStones} genuineStone />
      </Box>
    </Box>
  )
}

GenuineGemstones.propTypes = {
  refs: PropTypes.object,
}
export default GenuineGemstones
